import React, { useEffect, useState } from "react";
import fetchData from "Hooks/useAPI";
import useAuth from "Hooks/useAuth";
import InputField from "components/fields/InputField";
import ErrorMessage from "components/ErrorMessage";
import Spinner from "components/spinner";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import logo_mitaxi from '../../assets/img/logo_mitaxi.png'




const LOGIN_ENDPOINT = 'https://adandyou.host/users_app/api/index.php/login'




const SignIn = () => {
  const { login, authData } = useAuth()
  const navigate = useNavigate()
  useEffect(() => {

    const { token } = authData()

    if (token) {
      navigate('/admin')
    }

  })
  useEffect(() => {
    const { token } = queryString.parse(window.location.search);
    // Aquí puedes hacer lo que necesites con el token
    // Por ejemplo, guardar el token en localStorage
    if (token) {
      login(token)
      navigate('/admin')
    }

  });

  const useQuery = () => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  const urlCallback = useQuery().get('callback');
  if (urlCallback) {
    localStorage.setItem("callback", urlCallback)
  }
  console.log("URL callback", urlCallback)
  const [form, setForm] = useState({})
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)


  const btnClass = `${error ? 'shake' : ''} linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200`;
  const redirectSuccessLogin = (token) => {
    if (urlCallback) {
      window.location.href = `${urlCallback}?token=${token}`;
    } else {
      navigate('/admin')
    }
  }
  const loginHandler = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      const response = await fetchData(LOGIN_ENDPOINT, 'POST', form)
      const { token, user } = response
      const { email } = user
      login(token, email)
      redirectSuccessLogin(token)

    } catch (error) {
      console.log(error)
      setError(error?.response?.data?.message)
    } finally {
      setLoading(false)
    }
  }
  const handleChange = (field, value) => {
    try {
      setForm({ ...form, [field]: value });
    } catch (error) {
      console.log(error)
    }

  }
  return (
    <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
      {/* Sign in section */}
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <div className="w-full max-w-full flex items-center justify-center">
          <img alt="Mi taxi aeropuerto" src={logo_mitaxi} />
        </div>

        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Inicia sesión
        </h4>

        {/* Email */}
        <InputField
          variant="auth"
          extra="mb-3"
          label="Email*"
          placeholder="mail@simmmple.com"
          id="email"
          type="text"
          onChange={e => {
            e.preventDefault()
            handleChange('email', e.target.value)
          }}
        />

        {/* Password */}
        <InputField
          variant="auth"
          extra="mb-3"
          label="Password*"
          placeholder="Min. 8 characters"
          id="password"
          type="password"
          onChange={e => {
            e.preventDefault()
            handleChange('password', e.target.value)
          }}
        />
        {/* Checkbox */}
        <div className="mb-4 flex items-center justify-between px-2">
          <a
            className="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
            href=" "
          >
            Olvidaste tu contraseña?
          </a>
        </div>
        <button onClick={loginHandler} className={btnClass}>
          {loading ? <Spinner /> : 'Iniciar sesión'}
        </button>
        <div className="mt-4">
          {error ? <ErrorMessage text={error} /> : null}
        </div>
        <div className="mt-4">
          <span className=" text-sm font-medium text-navy-700 dark:text-gray-600">
            No estas registrado?
          </span>
          <a
            href="sign-up"
            className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
          >
            Crea tu cuenta
          </a>
        </div>
      </div>
    </div>
  );
}


export default SignIn